import { useEffect } from "react";

const PayU = (order) => {
  useEffect(() => {
    const loadPayUScript = () => {
      return new Promise((resolve, reject) => {
        const existingScript = document.getElementById("payu-affordability-widget");
        
        // If the script already exists, resolve immediately
        if (existingScript) {
          console.log("PayU script already loaded.");
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = "https://jssdk.payu.in/widget/affordability-widget.min.js";
        script.id = "payu-affordability-widget";
        script.onload = () => {
          console.log("PayU script loaded successfully.");
          resolve();
        }; // Resolve when script loads
        script.onerror = () => {
          console.error("Failed to load PayU script.");
          reject(new Error("Failed to load PayU script")); // Reject on error
        };

        document.body.appendChild(script);
      });
    };

    const initPayUWidget = async () => {
      try {
        await loadPayUScript(); // Load the script
        // Ensure payuAffordability is available after the script loads
        if (typeof window.payuAffordability !== "undefined") {
          const widgetConfig = { 
	          key: order.key,
	          amount: order.amount,
	          txnid: order.txnid,
	          hash: order.hash
	      };
          window.payuAffordability.init(widgetConfig);
        } else {
          console.error("payuAffordability is not defined yet.");
        }
      } catch (error) {
        console.error("Error loading PayU script:", error.message);
      }
    };

    initPayUWidget(); // Call the initialization function
  }, [order]); // Depend on props to reinitialize when they change
};

export default PayU;
